import React, { Component } from 'react'
import * as Yup from 'yup'
import { Formik, FormikProps, FormikErrors, FormikTouched } from 'formik'
import { noop } from 'helpers/common'
import { ApplicationData } from '../../services/api'

type FormValues = {
  [_: string]: any
}

type Step = {
  // TODO: Clarify which props are exposed and refactor to "render props" pattern to reduce coupling.
  slide: React.ComponentType<any>
  onSubmit?: (values: FormValues, formikProps: FormikProps<FormValues>) => void
  slideProps?: {
    // Temporary coupling on product data from this generic component until `slide` prop is refactored.
    applicationData: ApplicationData
    onBack?: () => void
    onClose?: () => void
  }
}

type Steps = {
  [_: string]: Step
}

type Props = {
  initialValues: object
  schema?: Yup.ObjectSchema<any>
  steps: Steps
  active: string
}

type State = {
  isSubmitting: boolean
  isSubmitted: boolean
}

class MultiStepForm extends Component<Props, State> {
  state = {
    isSubmitted: false,
    isSubmitting: false,
  }

  componentDidUpdate(prevProps: Props) {
    const { active } = this.props
    const { isSubmitting } = this.state
    if (prevProps.active !== active && isSubmitting) {
      this.setState({
        isSubmitting: false,
      })
    }
  }

  handleSubmit = (props: FormikProps<FormValues>) => {
    const { steps, active } = this.props
    const { onSubmit } = steps[active]
    this.setState({ isSubmitted: true }, () => {
      props.validateForm().then((errors: FormikErrors<FormValues>) => {
        if (Object.keys(errors).length) {
          return
        }
        props.setSubmitting(true)
        this.setState({ isSubmitting: true })
        if (onSubmit) {
          onSubmit(props.values, props)
        }
      })
    })
  }

  getErrors = (touched: FormikTouched<FormValues>, errors: FormikErrors<FormValues>) => {
    const { isSubmitted } = this.state
    const touchedFieldsWithErrors = Object.keys(touched).reduce((memo, item) => {
      memo[item] = errors[item]
      return memo
    }, {} as Record<string, string | FormikErrors<any> | undefined>)
    return isSubmitted ? errors : touchedFieldsWithErrors
  }

  render() {
    const { isSubmitting } = this.state
    const { steps, active, initialValues, schema } = this.props
    const { slide: ActiveSlide, slideProps } = steps[active]

    return (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={noop}
        render={(props) => (
          <ActiveSlide
            {...slideProps}
            values={props.values}
            errors={this.getErrors(props.touched, props.errors)}
            isSubmitting={isSubmitting && props.isSubmitting}
            setFieldValue={props.setFieldValue}
            setFieldError={props.setFieldError}
            setSubmitting={props.setSubmitting}
            resetForm={props.resetForm}
            handleChange={props.handleChange}
            handleSubmit={() => this.handleSubmit(props)}
          />
        )}
      />
    )
  }
}

export { MultiStepForm }
